module.exports = __webpack_public_path__ + "static/media/speed.30984222.png";